import { Component,  Inject, OnDestroy, OnInit, PLATFORM_ID } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';
import { Partner } from '../../models/partner/IPartner';
import { AuthGuardService } from '../../services/auth-guard.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { DOCUMENT, isPlatformBrowser } from '@angular/common';
@Component({
    selector: 'app-capmer',
    templateUrl: './capmer.component.html',
    styleUrls: ['./capmer.component.scss'],
    standalone: false
})
export class CapmerComponent implements OnInit, OnDestroy {
    private unsubscribe$ = new Subject();
    currentPart: Partner;
    src: string;
    isBrowser: boolean = false;
    constructor(
        private authService: AuthGuardService,
        private metaService: Meta,
        private titleService: Title,
        @Inject(DOCUMENT) protected document: any,
        @Inject(PLATFORM_ID) private platformId: any
    ) {
        this.isBrowser = isPlatformBrowser(this.platformId);
    }

    ngOnInit(): void {
        if (this.isBrowser) {
            this.setNoIndex();
            this.authService.getPartner$.pipe(
                takeUntil(this.unsubscribe$)
            ).subscribe((part) => {
                this.currentPart = part;
                this.document.body.style.overflow = 'hidden';
                this.document.body.style.height = '100%';
                this.src = 'https://camper.fti360.com/?benum=' + this.currentPart?.fti?.drive?.benum + '&lang=de&utm_source=b2b2c&utm_medium=iframe'
            });
        }
    }

    async setNoIndex() {
        this.metaService.updateTag({ name: 'robots', content: 'noindex' });
        this.titleService.setTitle('Camper');
    }

    
    ngOnDestroy() {
        if (this.isBrowser) {
            this.document.body.style.overflow = '';
            this.document.body.style.height = 'max-content';
        }
        this.unsubscribe$.next(true);
        this.unsubscribe$.complete();
    }
}
